<template>
  <div class="flipbook-container">
    <transition name="book-open">
      <Flipbook
          ref="flipbook"
          class="flipbook shadow-lg"
          :pages="pages" :zooms="null"
          v-slot="flip"
          clickToZoom="false"
          centering='true'
      >
        <div class="flipbook-controls">
          <button @click="flip.flipLeft()" class="nav-btn"><i class="mdi mdi-arrow-left" style="align-items: center"/> Trang trước</button>
          <span class="page-indicator">{{ flip.page }} / {{ flip.numPages }}</span>
          <button @click="flip.flipRight" class="nav-btn">Trang sau <i class="mdi mdi-arrow-right" style="align-items: center"/></button>
        </div>
      </Flipbook>
    </transition>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue";

export default {
  name: "PdfFlipbook",
  components: {Flipbook},
  data() {
    return {
      pages: [
        null,
        // require("@/assets/pdf_pages/SACHHOA-TRANG (1).jpg"),
        // require("@/assets/pdf_pages/SACHHOA-TRANG (2).jpg"),
        // require("@/assets/pdf_pages/SACHHOA-TRANG (3).jpg"),
        // require("@/assets/pdf_pages/SACHHOA-TRANG (4).jpg"),
        // require("@/assets/pdf_pages/SACHHOA-TRANG (5).jpg"),
        'https://picsum.photos/200/300?id=6',
        'https://picsum.photos/200/300?id=7',
        'https://picsum.photos/200/300?id=8',
        'https://picsum.photos/200/300?id=9',
        // ... thêm bao nhiêu trang tùy PDF bạn convert ra
      ],
    };
  },
  created() {
    // delay nhẹ để animation mượt hơn
    setTimeout(() => {
      this.showBook = true;
    }, 300);
  },
};
</script>
<style scoped>
/*  .flipbook-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 90vh;
    overflow: hidden;
    padding-top:1vh;
    padding-bottom: 9vh;
} */

.flipbook-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at center, #fafafa 0%, #e8e8e8 100%);
  min-height: 90vh;
  overflow: hidden;

  padding-top: 1vh;
  padding-bottom: 9vh;
  perspective: 2000px; /* Tạo chiều sâu 3D cho animation */
}

/* chiếm 90% màn hình */
.flipbook {
  width: 90vw;
  height: 90vh;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  background: #ffffff;
  transition: transform 0.45s linear;
}

.book-open-enter-active {
  animation: openBook 1.2s ease forwards;
  transform-style: preserve-3d;
}

@keyframes openBook {
  0% {
    transform: rotateY(-90deg) scale(0.8);
    opacity: 0;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    transform: rotateY(15deg) scale(1.03);
    opacity: 1;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  }
  100% {
    transform: rotateY(0deg) scale(1);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  }
}

.flipbook-controls {
  position: absolute;
  bottom: 10px;

  /* Giữ lại phần căn giữa tuyệt đối */
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.85);
  padding: 10px 24px;
  border-radius: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(6px);
}

.nav-btn {
  background-color: #efc62c;
  color: #222;
  font-weight: 600;
  border: none;
  border-radius: 20px;
  padding: 10px 18px;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-btn:hover {
  background-color: #ffd94f;
  transform: translateY(-2px);
}

.page-indicator {
  font-weight: 600;
  color: #0e1459;
  align-items: center;
  display: flex;
}
</style>
